import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["dataQaType", "value", "focused", "cobrowsingSecure", "maxLength", "maxLengthError", "highlightExtraSymbols"];
import React, { forwardRef, useCallback, useEffect, useRef, useState } from 'react';
import throttle from '@tinkoff/utils/function/throttle';
import { useControlledFocus } from '@platform-ui/focusUtils';
import { InlinePlaceholder, placeholderHOC } from '@platform-ui/inputTools';
import { useMergeRefs } from '@tui-react/core';
import styles from './TextareaValue.module.css';
export const TextareaValue = placeholderHOC(InlinePlaceholder)( /*#__PURE__*/forwardRef((props, forwardedRef) => {
  const selfRef = useRef(null);
  const wrapRef = useRef(null);
  const _useControlledFocus = useControlledFocus(_extends({}, props, {
      ref: useMergeRefs([selfRef, forwardedRef])
    })),
    {
      dataQaType,
      value,
      cobrowsingSecure,
      maxLength,
      maxLengthError,
      highlightExtraSymbols
    } = _useControlledFocus,
    otherProps = _objectWithoutPropertiesLoose(_useControlledFocus, _excluded);
  const [height, setHeight] = useState('auto');
  const updateHeight = useCallback(() => {
    const textarea = selfRef.current;
    const wrap = wrapRef.current;
    if (!textarea || !wrap) {
      return;
    }
    // фиксируем высоту чтобы избежать прыжков скролла
    wrap.style.height = textarea.style.height;
    textarea.style.height = 'auto';
    const {
      scrollHeight
    } = textarea;
    if (scrollHeight === 0) {
      return;
    }
    textarea.style.height = `${scrollHeight}px`;
    wrap.style.height = 'auto';
    setHeight(scrollHeight);
  }, []);
  useEffect(updateHeight, [value, updateHeight]);
  useEffect(() => {
    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(updateHeight);
      if (selfRef.current) {
        observer.observe(selfRef.current);
      }
      return () => {
        observer.disconnect();
      };
    }
    const onWindowResize = throttle(100, updateHeight);
    window.addEventListener('resize', onWindowResize);
    return () => {
      window.removeEventListener('resize', onWindowResize);
    };
  }, [updateHeight]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.wrap,
    ref: wrapRef
  }, value && highlightExtraSymbols && maxLengthError && /*#__PURE__*/React.createElement("div", {
    style: {
      height
    },
    className: styles.backdrop
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.highlights
  }, value.substring(0, maxLength), /*#__PURE__*/React.createElement("mark", {
    className: styles.mark
  }, value.substring(Number(maxLength))))), /*#__PURE__*/React.createElement("textarea", Object.assign({}, otherProps, {
    "data-qa-type": `${dataQaType}.input`,
    className: styles.textarea,
    value: value,
    style: _extends({}, otherProps.style || {}, {
      height,
      zIndex: highlightExtraSymbols && maxLengthError ? 2 : undefined
    }),
    placeholder: "",
    "data-cobrowsing-secure": cobrowsingSecure ? 'input' : ''
  })));
}));